import AsyncStorage from '@react-native-async-storage/async-storage';

import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface PromotionsStore {
    depositMatchPromo?: string;
    locallyOptedInPromos: string[];
    lastFetch: number;
    actions: {
        clearDepositMatchPromo: () => void;
        storeDepositMatchPromo: (promotion?: string) => void;
        handleLocalOptIn: (promoId: string) => void;
        clearLocallyOptedIn: () => void;
        setLastFetch: (timestamp: number) => void;
    };
}

export const usePromotionsStore = create<PromotionsStore>()(
    persist(
        set => {
            return {
                depositMatchPromo: undefined,
                locallyOptedInPromos: [],
                lastFetch: 0,
                actions: {
                    clearDepositMatchPromo: () => {
                        set({ depositMatchPromo: undefined });
                    },
                    storeDepositMatchPromo: promotion => {
                        set({ depositMatchPromo: promotion });
                    },
                    handleLocalOptIn: promoId =>
                        set(state => {
                            const newPromos = [...state.locallyOptedInPromos, promoId];

                            return { locallyOptedInPromos: newPromos };
                        }),
                    clearLocallyOptedIn: () => set({ locallyOptedInPromos: [] }),
                    setLastFetch: (timestamp: number) => set({ lastFetch: timestamp }),
                },
            };
        },
        {
            name: 'promotions-store',
            version: 4,
            storage: createJSONStorage(() => AsyncStorage),
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            partialize: ({ actions, locallyOptedInPromos, ...rest }: PromotionsStore) => rest,
        }
    )
);
